import { c as _c } from "react/compiler-runtime";
import { useChangeSeats } from "@components/table/members/assign-seats/use-change-seats";
/**
 * Returns how to give a member a seat of the workspace subscription, with the request, its tracking
 * and the toasts about it, see useChangeSeats.
 */
export function useAssignSeat() {
  const $ = _c(2);
  const {
    changeSeats
  } = useChangeSeats();
  let t0;
  if ($[0] !== changeSeats) {
    const assignSeat = function assignSeat(member, seat, location) {
      return changeSeats(member, [{
        seat,
        isAssigning: true
      }], location);
    };
    t0 = {
      assignSeat
    };
    $[0] = changeSeats;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}